import { observer } from 'mobx-react';
import React, { useEffect, useRef, useState } from 'react';
import { ASSIGNMENT_AND_CONVEYANCE_ENTITY_TYPE } from '../../../stores/documentForms/docusignStore';
import { Document } from '@roc/feature-types';
import { AssignmentAndConveyanceContentPage } from './assignmentAndConveyanceContentPage';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { Button, Grid, Typography } from '@material-ui/core';
import { SignatureFieldHandle, StandardDialog } from '@roc/ui';
import { useStore } from '@roc/client-portal-shared/hooks';
import { DocumentSigningStore } from '../../../stores/documentForms/documentSigningStore';

interface Props {
  onClose: () => void;
  open: boolean;
  document: Document;
  loan: any;
  store: DocumentSigningStore;
}

const AssignmentAndConveyanceDialog = observer((props: Props) => {
  const { open, onClose, document, loan, store } = props;
  const { globalStore } = useStore();
  const taskId = document?.taskId;
  const signatureRef = useRef<SignatureFieldHandle>(null);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if(open) {
      store.validateAssignmentAndConveyanceDocument(loan.loanId);
    }
  }, [open]);

  useEffect(() => {
    setErrorMessage(store.assignmentAndConveyanceErrorMessage);
  }, [store.assignmentAndConveyanceErrorMessage]);

  const handleSubmit = () => {
    if (signatureRef.current.isSigned()) {
      generateDocument();
      onClose();
    } else {
      globalStore.notificationStore.showErrorNotification({
        message: 'Please sign the document before submitting it',
      });
    }
  };

  const generateDocument = async () => {
    const signatureURL = signatureRef.current.getSignature();
    await store.generateAssignmentAndConveyanceDocument(signatureURL, loan.loanId);
  }

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          title={'Assignment & Conveyance'}
          open={open}
          maxWidth={'lg'}
          handleClose={onClose}
          dialogContent={
            <Grid container >
              <Grid item xs={12}>
                {errorMessage ? (
                  <Typography variant="body1">
                    Document signing is not currently available. {errorMessage}.
                  </Typography>
                ) : (
                  <AssignmentAndConveyanceContentPage signatureRef={signatureRef} loan={loan} handleSubmit={handleSubmit} />
                )}
              </Grid>
            </Grid>
          }
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          title={'Assignment & Conveyance'}
          open={open}
          maxWidth={'lg'}
          handleClose={onClose}
          dialogContent={
            <Grid container >
              <Grid item xs={12}>
                {errorMessage ? (
                  <Typography variant="body1">
                    Document signing is not currently available. {errorMessage}.
                  </Typography>
                ) : (
                  <AssignmentAndConveyanceContentPage signatureRef={signatureRef} loan={loan} handleSubmit={handleSubmit} />
                )}
              </Grid>
            </Grid>
          }
        />
      )}
    </>
  );
});

export default AssignmentAndConveyanceDialog;
